import React, { FC } from 'react'
import HowItWorks from '@components/HowItWorks'
import { SCard, SColumn, SShortCard, SSingleColumn } from '@components/HowItWorks/SComponents'
import Money from '@icons/money-aero.inline.svg'
import Chart from '@icons/chart-aero.inline.svg'
import Safe from '@icons/safe-aero.inline.svg'
import { SH3, SParagraph } from '@components/Typography'
import Background from '@components/HowItWorks/Background'
import { aeroLines as lines } from '@components/HowItWorks/Background/icons'
import { SLink } from '@/pages/aero'

const HowItWorksOnAero: FC = () => (
  <HowItWorks backgroundComponent={<Background lines={lines} />}>
    <SColumn>
      <SShortCard
        icon={<Money />}
        price="10 000"
        heading="Взносы работника"
        more={
          <>
            <SH3 color="white">ПАО Аэрофлот софинансирует 20% от взноса сотрудника</SH3>
            <SParagraph m={0} color="white">
              Вы самостоятельно выбираете сумму взносов, указываете ее в заявлении на удержание из заработной платы,
              которое подаете в бухгалтерию
            </SParagraph>
          </>
        }
      >
        Предположим, Ваш взнос
      </SShortCard>
      <SShortCard
        icon={<Money />}
        price="2000"
        heading="Взносы Аэрофлот (20%)"
        more={<SH3 color="white">ПАО Аэрофлот софинансирует ежемесячно 20% от взноса сотрудника</SH3>}
      >
        Софинансирование
      </SShortCard>
    </SColumn>
    <SSingleColumn>
      <SShortCard icon={<Chart />} heading="Инвестиционный доход от СберНПФ">
        <SLink
          href="https://npfsberbanka.ru/about/information-to-be-disclosed/results/?utm_source=lp_aero_how#graph"
          target="_blank"
          rel="noreferrer"
        >
          Начисления
          <br />
          инвестиционного дохода
        </SLink>
      </SShortCard>
    </SSingleColumn>
    <SColumn>
      <SCard icon={<Safe />} heading="Именной пенсионный счет">
        Всегда принадлежит работнику
      </SCard>
      <SCard
        icon={<Safe />}
        heading="Корпоративный пенсионный счет"
        more={
          <>
            <SH3 color="white">В виде пенсии</SH3>
            <SParagraph mb="20px" color="white">
              сроком не менее 5 лет - при достижении пенсионных оснований
            </SParagraph>
            <SH3 color="white">В виде единовременной выплаты</SH3>
            <SParagraph m={0} color="white">
              При участии в программе более 5 лет
            </SParagraph>
          </>
        }
      >
        Получить средства
        <br />
        работник может
        <br />
        при условиях
      </SCard>
    </SColumn>
  </HowItWorks>
)

export default HowItWorksOnAero
